export const Navigation = (props) => {
  return (
    <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
      <div className='container'>
        <div className='navbar-header'>
          <button
            type='button'
            className='navbar-toggle collapsed'
            data-toggle='collapse'
            data-target='#bs-example-navbar-collapse-1'
          >
            {' '}
            <span className='sr-only'>Toggle navigation</span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
            <span className='icon-bar'></span>{' '}
          </button>
          <a href='#top'>
            <img className="logo" src="/img/logo.svg" alt="studio365" />
          </a>{' '}
        </div>

        <div
          className='collapse navbar-collapse'
          id='bs-example-navbar-collapse-1'
        >
          <ul className='nav navbar-nav navbar-right'>
            <li>
              <a href='#studio' className='page-scroll'>
                Studio
              </a>
            </li>
            <li>
              <a href='#productions' className='page-scroll'>
                Produções
              </a>
            </li>
            <li>
              <a href='#contact-us' className='page-scroll'>
                Saiba Mais
                <span className="arrow">→</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  )
}
